import Vue from 'vue'

const downloadStore = Vue.observable({
  active: false,
  activeType: null,
})

downloadStore.start = function (type) {
  this.active = true
  this.activeType = type
}

downloadStore.finish = function () {
  this.active = false
  this.activeType = null
}

export default downloadStore
